const styles = theme => ({
  courseLeftSideRootOpen: {
    display: 'flex',
    position: 'relative',
    minWidth: '280px',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  courseLeftSideRoot: {
    display: 'flex',
    position: 'relative',
    minWidth: '56px',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
})
export default styles
